import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import Vuex from 'vuex'
import App from './App.vue';
import PenthouseDetailed from './pages/PenthouseDetailed.vue'
import PenthouseList from './pages/PenthouseList.vue'
import { store } from './store'
import "@babel/polyfill"

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueMeta,{
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}


const routes = [
  { path: '/penthouse-selection/penthouse/:pentNumber', component: PenthouseDetailed },
  { path: '/penthouse-selection', component: PenthouseList}
]

export const router = new VueRouter({
  mode: 'history',
  routes 
})

const rootElement = document.createElement('div');
document.querySelector('.custom-page').appendChild(rootElement);
new Vue({ router, store, render: createElement => createElement(App) }).$mount(rootElement);